<template>
    <div
        class="tw-w-full tw-min-h-[300px] tw-bg-white tw-rounded-lg tw-p-2 tw-border tw-border-solid tw-border-primary-200">
        <!-- Company Dashboard Navigation -->
        <div class="tw-space-y-2">
            <!-- Home -->
            <router-link 
                :to="{ name: 'pages.company.dashboard' }"
                :class="[
                    'tw-w-full tw-p-3 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                    $route.name === 'pages.company.dashboard'
                        ? 'tw-bg-primary-500 tw-text-white'
                        : 'tw-bg-white tw-text-gray-700 hover:tw-bg-primary-50 hover:tw-text-primary-700'
                ]">
                <div :class="[
                    'tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0',
                    $route.name === 'pages.company.dashboard' ? 'tw-text-white' : 'tw-text-gray-500'
                ]">
                    <icon icon="solar:home-smile-linear" class="tw-text-lg" />
                </div>
                <span class="tw-font-medium tw-text-sm">Home</span>
            </router-link>

            <!-- Company Profile (Expandable) -->
            <div>
                <div @click="toggleCompanyProfile" :class="[
                    'tw-w-full tw-p-3 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200',
                    isCompanyProfileExpanded
                        ? 'tw-bg-primary-500 tw-text-white'
                        : 'tw-bg-white tw-text-gray-700 hover:tw-bg-primary-50 hover:tw-text-primary-700'
                ]">
                    <div :class="[
                        'tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0',
                        isCompanyProfileExpanded ? 'tw-text-white' : 'tw-text-gray-500'
                    ]">
                        <icon icon="solar:buildings-2-linear" class="tw-text-lg" />
                    </div>
                    <span class="tw-font-medium tw-text-sm tw-flex-1">Company profile</span>
                    <div :class="[
                        'tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center tw-transition-transform tw-duration-200',
                        isCompanyProfileExpanded ? 'tw-rotate-180' : ''
                    ]">
                        <icon icon="solar:alt-arrow-down-linear" class="tw-text-sm" />
                    </div>
                </div>

                <!-- Company Profile Sub-items -->
                <div v-if="isCompanyProfileExpanded" class="tw-ml-6 tw-mt-2 tw-space-y-1">
                    <!-- Overview - HIDDEN FOR NOW -->
                    <!-- <router-link 
                        :to="{ name: 'pages.company.profile' }"
                        :class="[
                            'tw-w-full tw-p-2 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                            $route.name === 'pages.company.profile'
                                ? 'tw-bg-primary-100 tw-text-primary-700'
                                : 'tw-bg-white tw-text-gray-600 hover:tw-bg-gray-50 hover:tw-text-gray-800'
                        ]">
                        <span class="tw-text-sm">Overview</span>
                    </router-link> -->

                    <!-- Documents -->
                    <router-link 
                        :to="{ name: 'pages.company.documents' }"
                        :class="[
                            'tw-w-full tw-p-2 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                            $route.name === 'pages.company.documents'
                                ? 'tw-bg-primary-100 tw-text-primary-700'
                                : 'tw-bg-white tw-text-gray-600 hover:tw-bg-gray-50 hover:tw-text-gray-800'
                        ]">
                        <span class="tw-text-sm tw-font-medium">Documents</span>
                    </router-link>

                    <!-- Products -->
                    <router-link 
                        :to="{ name: 'pages.company.products' }"
                        :class="[
                            'tw-w-full tw-p-2 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                            $route.name === 'pages.company.products'
                                ? 'tw-bg-primary-100 tw-text-primary-700'
                                : 'tw-bg-white tw-text-gray-600 hover:tw-bg-gray-50 hover:tw-text-gray-800'
                        ]">
                        <span class="tw-text-sm">Products</span>
                    </router-link>

                    <!-- Services -->
                    <router-link 
                        :to="{ name: 'pages.company.services' }"
                        :class="[
                            'tw-w-full tw-p-2 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                            $route.name === 'pages.company.services'
                                ? 'tw-bg-primary-100 tw-text-primary-700'
                                : 'tw-bg-white tw-text-gray-600 hover:tw-bg-gray-50 hover:tw-text-gray-800'
                        ]">
                        <span class="tw-text-sm">Services</span>
                    </router-link>
                </div>
            </div>

            <!-- Meetings -->
            <router-link 
                :to="{ name: 'pages.company.meetings' }"
                :class="[
                    'tw-w-full tw-p-3 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                    $route.name === 'pages.company.meetings'
                        ? 'tw-bg-primary-500 tw-text-white'
                        : 'tw-bg-white tw-text-gray-700 hover:tw-bg-primary-50 hover:tw-text-primary-700'
                ]">
                <div :class="[
                    'tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0',
                    $route.name === 'pages.company.meetings' ? 'tw-text-white' : 'tw-text-gray-500'
                ]">
                    <icon icon="solar:users-group-rounded-linear" class="tw-text-lg" />
                </div>
                <span class="tw-font-medium tw-text-sm">Meetings</span>
            </router-link>

            <!-- Contacts -->
            <router-link 
                :to="{ name: 'pages.company.contacts' }"
                :class="[
                    'tw-w-full tw-p-3 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                    $route.name === 'pages.company.contacts'
                        ? 'tw-bg-primary-500 tw-text-white'
                        : 'tw-bg-white tw-text-gray-700 hover:tw-bg-primary-50 hover:tw-text-primary-700'
                ]">
                <div :class="[
                    'tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0',
                    $route.name === 'pages.company.contacts' ? 'tw-text-white' : 'tw-text-gray-500'
                ]">
                    <icon icon="solar:user-id-linear" class="tw-text-lg" />
                </div>
                <span class="tw-font-medium tw-text-sm">Contacts</span>
            </router-link>

            <!-- Team -->
            <router-link 
                :to="{ name: 'pages.company.team' }"
                :class="[
                    'tw-w-full tw-p-3 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                    $route.name === 'pages.company.team'
                        ? 'tw-bg-primary-500 tw-text-white'
                        : 'tw-bg-white tw-text-gray-700 hover:tw-bg-primary-50 hover:tw-text-primary-700'
                ]">
                <div :class="[
                    'tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0',
                    $route.name === 'pages.company.team' ? 'tw-text-white' : 'tw-text-gray-500'
                ]">
                    <icon icon="solar:users-group-two-rounded-linear" class="tw-text-lg" />
                </div>
                <span class="tw-font-medium tw-text-sm">Team</span>
            </router-link>

            <!-- Settings -->
            <router-link 
                :to="{ name: 'pages.company.settings' }"
                :class="[
                    'tw-w-full tw-p-3 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200 tw-no-underline',
                    $route.name === 'pages.company.settings'
                        ? 'tw-bg-primary-500 tw-text-white'
                        : 'tw-bg-white tw-text-gray-700 hover:tw-bg-primary-50 hover:tw-text-primary-700'
                ]">
                <div :class="[
                    'tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0',
                    $route.name === 'pages.company.settings' ? 'tw-text-white' : 'tw-text-gray-500'
                ]">
                    <icon icon="solar:settings-linear" class="tw-text-lg" />
                </div>
                <span class="tw-font-medium tw-text-sm">Settings</span>
            </router-link>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useRoute } from "vue-router";

const route = useRoute();

// Company profile expandable state
const isCompanyProfileExpanded = ref(false);

// Check if current route is within company profile section
const isInCompanyProfileSection = computed(() => {
    return ['pages.company.documents', 'pages.company.products', 'pages.company.services'].includes(route.name);
});

// Auto-expand company profile section if user is on a company profile page
watch(() => route.name, (newRouteName) => {
    newRouteName
    if (isInCompanyProfileSection.value) {
        isCompanyProfileExpanded.value = true;
    }
}, { immediate: true });

// Toggle company profile section
const toggleCompanyProfile = () => {
    isCompanyProfileExpanded.value = !isCompanyProfileExpanded.value;
};
</script>

<style scoped></style>